import { render } from "./NavigationFooter.vue?vue&type=template&id=07d0cd7c"
const script = {}
script.render = render

export default script